import React from 'react';
import { Link } from 'react-router-dom';
import './Blogs.css';
const blogData = [
  {
    id: 1,
    slug: '/How-Jewellery-Brands-Can-Scale-Product-Catalogs-Without-Increasing-Photoshoot-Costs',
    image: '/assets/img/website/blog/blog_1.jpg',
    title: 'How Jewellery Brands Can Scale Product Catalogs Without Increasing Photoshoot Costs',
    date: '23 Mar, 2026',
  },
  {
    id: 2,
    slug: '/AI-Jewellery-Images-12-Mistakes-That-Make-Products-Look-Fake-And-Fixes',
    image: '/assets/img/website/blog/blog_2.jpg',
    title: 'AI Jewellery Images: 12 Mistakes That Make Products Look Fake (And Fixes)',
    date: '31 Mar, 2026',
  },
  {
    id: 3,
    slug: '/Bust-vs-Full-Human-Model-Which-Jewellery-Visual-Converts-Better',
    image: '/assets/img/website/blog/blog_3.jpg',
    title: 'Bust vs Full Human Model: Which Jewellery Visual Converts Better?',
    date: '31 Mar, 2026',
  },
  // {
  //   id: 4,
  //   slug: '/How-Jewellery-Brands-Can-Scale-Product-Catalogs-Without-Increasing-Photoshoot-Costs',
  //   image: '/assets/img/website/blog-1.png',
  //   title: 'How Jewellery Brands Can Scale Product Catalogs Without Increasing Photoshoot Costs',
  //   date: '23 Mar, 2026',
  // },
];

const Blogs = ({ showHeading = true, maxItems, showViewAll = false }) => {
  const displayedBlogs = maxItems ? blogData.slice(0, maxItems) : blogData;


  return (
    <section className="blogs-section sections bg-white pt-0">
      <div className="container-fluid">
        {showHeading && (
          <div className="row justify-content-center">
            <div className="col-md-11 col-lg-11 ps-md-4 pe-md-4 text-start section-headings blogs-heading-wrap d-flex justify-content-between align-items-center flex-wrap gap-3">
              <h2 className="font-heading mb-md-0 mb-3">
                <span className="blogs-heading-purple">Glammify</span>{' '}
                <span className="blogs-heading-black">Insights</span>
              </h2>
              {showViewAll && (
                <Link to="/blogs" className="view-all-post-btn d-none d-md-flex">
                  View All Post
                </Link>
              )}
            </div>
          </div>
        )}
        <div className="row justify-content-center">
          <div className="col-md-11 col-lg-11 ps-md-4 pe-md-4">
            <div className="blogs-grid-wrap">
              <div className="row">
                {displayedBlogs.map((blog) => (
                  <div key={blog.id} className="col-lg-4 col-md-6 mb-4">
                    <div className="blog-slide-item">
                      <Link
                        to={blog.slug}
                        className="blog-card-link"
                      >
                        <div className="blog-card">
                          <div className="blog-card-img-wrap">
                            <img
                              src={blog.image}
                              alt={blog.title}
                              className="blog-card-img"
                            />
                          </div>
                          <div className="blog-card-body">
                            <h4 className="blog-card-title">{blog.title}</h4>
                            <p className="blog-card-date">{blog.date}</p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
              {showViewAll && (
                <div className="row d-md-none mt-2">
                  <div className="col-12 d-flex justify-content-center">
                    <Link to="/blogs" className="view-all-post-btn">
                      View All Post
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blogs;
